
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PolicyDetailsFieldsProps {
  policyNumber: string;
  premiumAmount: number;
  onPolicyNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPremiumAmountChange: (value: number) => void;
}

export const PolicyDetailsFields = ({
  policyNumber,
  premiumAmount,
  onPolicyNumberChange,
  onPremiumAmountChange,
}: PolicyDetailsFieldsProps) => {
  // Handle numeric input for premium amount
  const handlePremiumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const numericValue = parseFloat(value) || 0;
    onPremiumAmountChange(numericValue);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2.5">
        <Label htmlFor="policyNumber" className="text-sm font-medium text-gray-700">Policy Number</Label>
        <Input
          id="policyNumber"
          value={policyNumber}
          onChange={onPolicyNumberChange}
          placeholder="Enter policy number"
          className="h-14 px-4 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
        />
      </div>
      <div className="space-y-2.5">
        <Label htmlFor="premiumAmount" className="text-sm font-medium text-gray-700">Premium Amount</Label>
        <Input
          id="premiumAmount"
          type="number"
          value={premiumAmount || ''}
          onChange={handlePremiumChange}
          placeholder="Enter premium amount"
          min="0"
          step="0.01"
          className="h-14 px-4 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
        />
      </div>
    </div>
  );
};
